// plugins/fetchSiteInfo.js
import { useMainStore } from "~/composables/store"; // 引入 Pinia Store
import { getCurrentServer } from "../utils/globalData";
export default defineNuxtPlugin(async (nuxtApp) => {
  // if (process.server) {
    const store = useMainStore();
    const headers = useRequestHeaders();
    const customFetch = (url, options) => (nuxtApp.$customFetch || $fetch)(url, options, headers);
   
    const currentServer = getCurrentServer(headers);

    // 在插件加载时调用 fetchSiteInfo 方法
    await store.fetchSiteInfo(currentServer, customFetch, headers);
    await store.fetchStoreInfo(currentServer, customFetch, headers);
    await store.fetchLayoutConfig(customFetch, headers);
    await store.fetchSiteMenu(customFetch, headers);
  // }
});
